import { faChevronDown, faLifeRing } from "@fortawesome/pro-solid-svg-icons";
import cx from "classnames";
import React from "react";

import { STROLLER_REVIEW_MENU_MORE } from "@/mk2/apps/strollers/containers/StrollerReviews/StrollerReviewsPage";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { MenuItem } from "@/mk2/components/menu/MenuItem";
import { Menu } from "@/mk2/containers/Menu/Menu";
import { url } from "@/mk2/helpers/urls";
import { StrollerUserReviewEntity } from "@/mk2/schemas";
import { FORUM_POST_ADMINCLUB_MENU } from "@/mk/autogenerated/translation";
import { adminclub_strollers_reviews_url } from "@/mk/urls/functions";

import styles from "./ReviewMenu.mscss";

interface OwnProps {
    className?: string;
    review: StrollerUserReviewEntity;

    onToggleMenuMore(reviewId: number);
}

type Props = OwnProps;

export default class ReviewMenu extends React.Component<Props> {
    public render() {
        const { className, review } = this.props;

        return (
            <Menu
                className={cx(styles.ReviewMenu, className)}
                menuId={STROLLER_REVIEW_MENU_MORE(review.id)}
                trigger={
                    <Btn
                        type={BtnType.GreyText}
                        icon={faChevronDown}
                        onClick={this.handleOnToggleMenuMore}
                    />
                }
            >
                <MenuItem
                    className={styles.ReviewMenu__item}
                    label={FORUM_POST_ADMINCLUB_MENU}
                    icon={faLifeRing}
                    link={url(
                        adminclub_strollers_reviews_url(),
                        {},
                        {
                            reviews_tab: "detail",
                            id: review.id,
                        },
                    )}
                    asAnchor
                    isAdminUI
                />
            </Menu>
        );
    }

    private handleOnToggleMenuMore = () => {
        const { review, onToggleMenuMore } = this.props;
        onToggleMenuMore(review.id);
    };
}
